const hotels = {
  back: "Di ritorno", // translated
  rooms: "Camere", // translated
  viewPictures: "Visualizza le immagini", // translated
  showMore: "mostra di più", // translated
  bookingInformation: "Informazioni sulla prenotazione", // translated
  cancellationPolicy: "Politica di cancellazione", // translated
  from: "A partire dal", // translated
  to: "UN", // translated
  cancellationIs: "la cancellazione è", // translated
  free: "libero", // translated
  chargeableWithFeeOf: "addebitabile con un canone di", // translated
  prebook: "Prenota in anticipo", // translated
  guests: "Ospiti", // translated
  payment: "Pagamento", // translated
  byClicking: "Cliccando", // translated
  next: "Prossimo", // translated
  youAreAgreeingToOur: "stai accettando il nostro", // translated
  termsAndConditions: "Termini e Condizioni", // translated
  previous: "Precedente", // translated
  cancel: "Annulla", // translated
  mealPlan: "Piano pasto", // translated
  roomType: "Tipo di stanza", // translated
  description: "Descrizione", // translated
  readLess: "Leggi meno", // translated
  readMore: "Leggi di più", // translated
  facilities: "Strutture", // translated
  viewLess: "Visualizza di meno", // translated
  viewMore: "Visualizza di più", // translated
  less: "meno", // translated
  more: "di più", // translated
  notAvailable_short: "N / A", // translated
  backToHotelList: "Torna all'elenco degli hotel", // translated
  viewOnMap: "Visualizza sulla mappa", // translated
  sleeps: "Dorme", // translated
  adults: "Adulti", // translated
  yearsOld: "Anni", // translated
  type: "Tipo", // translated
  bedding: "Biancheria da letto", // translated
  selectRoom: "Seleziona Stanza", // translated
  city: "Città", // translated
  checkIn: "Registrare", // translated
  checkOut: "Guardare", // translated
  date: "Data", // translated
  persons: "Persone", // translated
  stillOnTrialQuestionToUpgrade: "Ops! Sembra che tu abbia ancora un abbonamento di prova. Devi essere un membro confermato per effettuare le prenotazioni. Vuoi aggiornare ora?", // translated
  stillOnTrialQuestionToUpgradeNonElligib: "Ops! Sembra che tu non sia ancora iscritto. Devi essere un membro confermato per effettuare le prenotazioni. Vuoi aggiornare ora?", // translated
  completeProfile: "Si prega di completare prima il profilo utente", // translated
  upgrade: "Aggiornamento", // translated
  close: "Chiudere", // translated
  viewDetails: "Visualizza dettagli", // translated
  name: "Nome", // translated
  rating: "Valutazione", // translated
  budget: "Bilancio", // translated
  orderBy: "Ordinato da", // translated
  priceLowestFirst: "Prezzo (prima il più basso)", // translated
  priceHighestFirst: "Prezzo (prima il più alto)", // translated
  ratingLowestFirst: "Valutazione (prima la più bassa)", // translated
  ratingHighestFirst: "Valutazione (prima la più alta)", // translated
  starRatingAndPrice: "Classificazione a stelle e prezzo", // translated
  select: "Selezionare", // translated
  reset: "Ripristina", // translated
  apply: "Applicare", // translated
  filterBy: "Filtra per", // translated
  myProfile: "Il mio profilo", // translated
  login: "Login", // translated
  roomOnly: "Solo la stanza", // translated
  bedAndBreakfast: "Bed & Breakfast", // translated
  halfBoard: "Mezza pensione", // translated
  fullBoard: "Pensione completa", // translated
  allInclusive: "Tutto incluso", // translated
  filter: "Filtro", // translated
  mapView: "Vista mappa", // translated
  results: "risultati", // translated
  listView: "Visualizzazione elenco", // translated
  newSearch: "Nuova ricerca", // translated
  editSearch: "Modifica ricerca", // translated
  all: "Tutti", // translated
  multiple: "Multiplo", // translated
  editProfile: "Modifica Profilo", // translated
  backToHotelsList: "Torna all'elenco degli hotel", // translated
  roomName: "Nome della stanza", // translated
  mealType: "Tipo di pasto", // translated
  freeCancellation: "Cancellazione gratuita", // translated
  yes: "sì", // translated
  no: "NO", // translated
  filters: "Filtri", // translated
  cancellationNonRefundable: "La cancellazione non è rimborsabile", // translated
  accommodation: "Alloggio", // translated
  hotels: "Alberghi", // translated
  any: "Qualunque", // translated
  selectRooms: "Seleziona stanze", // translated
  performNewSearch: "Esegui una nuova ricerca", // translated
  dates: "Date", // translated
  hotel: "Hotel", // translated
  biggestSavingsFirst: "Prima il risparmio più grande", // translated
  off: "Spento", // translated
  hotelRating: "Valutazione dell'hotel", // translated
};

export default hotels;
